/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rowLine[_ngcontent-%COMP%]{margin:5px;background-color:var(--background-quaternary)!important;color:var(--foreground-quaternary)!important}.labelLine[_ngcontent-%COMP%]{background-color:var(--background-quaternary)!important;color:var(--foreground-quaternary)!important}"];
export { styles as styles };
